<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.2062 16.475L17.2562 10.525C16.8562 10.125 16.2312 10.125 15.8312 10.525L13.8812 12.475L11.5312 10.125L13.4812 8.17499C13.8812 7.77499 13.8812 7.15 13.4812 6.75L7.5312 0.799988C7.1312 0.399988 6.50621 0.399988 6.10621 0.799988L0.781195 6.125C0.581195 6.325 0.481207 6.57501 0.481207 6.82501C0.481207 7.10001 0.581195 7.35003 0.781195 7.52503L6.73121 13.475C6.93121 13.675 7.18119 13.775 7.43119 13.775C7.68119 13.775 7.9312 13.675 8.1312 13.475L10.0812 11.525L12.4312 13.875L10.4812 15.825C10.0812 16.225 10.0812 16.85 10.4812 17.25L16.4312 23.2C16.6312 23.4 16.8812 23.5 17.1312 23.5C17.4062 23.5 17.6562 23.4 17.8312 23.2L23.1562 17.875C23.6062 17.5 23.6062 16.85 23.2062 16.475ZM7.45621 11.35L2.93119 6.82501L6.83121 2.92499L11.3562 7.45001L10.1062 8.70001L9.35621 7.95001C8.95621 7.55001 8.33119 7.55001 7.93119 7.95001C7.53119 8.35001 7.53119 8.975 7.93119 9.375L8.68119 10.125L7.45621 11.35ZM17.1812 21.075L12.6562 16.55L13.9062 15.3L14.6562 16.05C14.8562 16.25 15.1062 16.35 15.3562 16.35C15.6062 16.35 15.8562 16.25 16.0562 16.05C16.4562 15.65 16.4562 15.025 16.0562 14.625L15.3062 13.875L16.5562 12.625L21.0812 17.15L17.1812 21.075Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: 'copyLinkIcon',
    props: {
      fill: {
        type: String,
        default: '#109CF1'
      }
    }
  }
</script>
